import React from 'react'
import { useAppSelector } from '../../../../hooks/redux'

import DueDateComponent from '../DueDateComponent'
import ColourIndicator from '../../../Settings/Controls/Edit/ColourIndicator'
import Title from '../Title'

import { selectTaskStatus } from '../../../../slices/taskStatus'
import useStyles from './styles'

type MobileDefaultProps = {
  task: APITask
  onMove?: (id: string) => void
}

const MobileDefault: React.FC<MobileDefaultProps> = ({ task, onMove }) => {
  const { statuses } = useAppSelector(selectTaskStatus)

  const colour = React.useMemo(
    () => statuses.find(({ id }) => id === task.status_id)?.colour ?? null,
    [statuses, task.status_id]
  )

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div style={{ flexBasis: '25%', textAlign: 'center', flexShrink: 0 }}>
        <DueDateComponent task={task} mobile />
      </div>

      <div className={classes.color}>
        {/* @ts-ignore */}
        <ColourIndicator colour={colour} />
      </div>

      <div style={{ flexBasis: '75%' }}>
        <Title lighter={false} task={task} mobile onMove={onMove} />
      </div>
    </div>
  )
}

export default React.memo(MobileDefault)
